// src/request/constants.ts
var GET_MATCH_RESULT = /* @__PURE__ */ Symbol();
export {
  GET_MATCH_RESULT
};
